export const WHATSAPP_LINK = 'https://api.whatsapp.com/send?phone=56986330929&text=Hola!%20Quiero%20cambiar%20mi%20n%C3%BAmero%20de%20celular';
